"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.componentsMicrosoft_en_us = void 0;
function componentsMicrosoft_en_us() {
    return {
        "components.microsoftfiles.nofolderset": "No folder set",
        "components.microsoftfiles.changefolder": "Change Folder",
        "components.microsoftfiles.setfolder": "Set Folder",
        "components.microsoftfiles.openfolder": "Open Folder",
        "components.microsoftfiles.removefolder": "Unlink Folder",
        "components.microsoftfiles.dialogtitle": "Select Microsoft 365 folder",
        "components.microsoftfiles.directoryup": "Folder up",
        "components.microsoftfiles.nodrive": "No sharepoint folder linked"
    };
}
exports.componentsMicrosoft_en_us = componentsMicrosoft_en_us;
